import React, {useContext, useEffect} from 'react';
import {Link, NavLink} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {Loading} from '../../custom/LoadingComponent'
import * as CustomStyles from '../../styles/CustomStyles';
import * as TypeConvertor from '../../util/TypeConvertor';
import * as Formatter from '../../util/Formatter';
import BucketContext from '../../context/BucketContext';
import * as Security from '../../../utils/auth/Security';
import * as Consts from '../../constants/Consts';
import { TaskStatus, TaskType } from '../../constants/Consts';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';


const columns = [
    {
        field: 'taskId',
        headerName: 'ID',
        width: 75,
        valueGetter: (params) => params.row.id,
        renderCell: (params) => {
            if(params.row.details.status === TaskStatus.Cancelled) {
                return(
                    params.row.id
                );
            }
            else if(params.row.details.type === TaskType.CouponStampRenewal) {
                return(
                    <Link to={`/rsvti/deserventi/tasks/couponstamp/${params.row.id}`}>
                        {params.row.id}
                    </Link>
                );
            }            else{
                return(
                    <Link to={`/rsvti/deserventi/tasks/certificate/${params.row.id}`}>
                        {params.row.id}
                    </Link>
                );
            }
        }
    },
    {
        field: 'taskName',
        headerName: 'Task',
        width: 200,
        valueGetter: (params) => TypeConvertor.getDeserventiTaskName(params.row.details.type)
    },
    {
        field: 'taskDate',
        headerName: 'Data Programare',
        width: 125,
        valueGetter: (params) => params.row.step0.scheduledDate,
        renderCell: (params) => {
            return(Formatter.formatDatetoRO(params.row.step0.scheduledDate));
        }
    },
    {
        field: 'taskStatus',
        headerName: 'Status',
        width: 80,
        valueGetter: (params) => TypeConvertor.getDeserventiTaskStatus(params.row.details.status)
    },
    {
        field: 'taskLocation',
        headerName: 'Locatie',
        width: 375,
        valueGetter: (params) => !!params.row.step1?.employerName ? params.row.step1.employerName + ' - ' +  params.row.step1.worksiteName : ''
    },
    {
        field: 'createDate',
        headerName: 'Data Creare',
        width: 110,
        valueGetter: (params) => params.row.createDate,
        renderCell: (params) => {
            return(Formatter.formatDatetoRO(params.row.createDate));
        }
    },
    {
        field: 'createBy',
        headerName: 'Creat De',
        width: 150,
        valueGetter: (params) => params.row.createBy?.updateByFullName,
    },
    {
        field: 'updateDate',
        headerName: 'Actualizare',
        width: 110,
        valueGetter: (params) => params.row.updateDate ? params.row.updateDate : '',
        renderCell: (params) => {
            return(params.row.updateDate ? Formatter.formatDatetoRO(params.row.updateDate) : '');
        }
    },
    {
        field: 'updateBy',
        headerName: 'Actualizat De',
        width: 150,
        valueGetter: (params) => params.row.updateBy?.updateByFullName,
    },
];


function TasksDeserventi(props) {
    console.log('TasksDeserventi');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();
    }, []);

    var contextClientId = '';
    if( !!bucketContext.bucket.userContext?.clientId ){
        contextClientId = bucketContext.bucket.userContext.clientId != Consts.COREVO_CLIENT_ID ? bucketContext.bucket.userContext.clientId : '';
    }

    const clientSelectData = TypeConvertor.getClientSelectData(props.clients);
    const [selectedClientId, setSelectedClientId] = React.useState( contextClientId );

    const [selectedTaskStatus, setSelectedTaskStatus] = React.useState( TaskStatus.InProgress );
    const [anchorNewTask, setAnchorNewTask] = React.useState(null);

    const taskSelectedData = props.rsvtiTasks.tasks.filter(task => task.details.status === selectedTaskStatus)

    const handleClientChange = (clientId) => {
        setSelectedClientId(clientId);
        bucketContext.setBucketValue({userContext: {clientId: clientId}});
    }

    const handleSelectStatusChange = (taskStatus) => {
        setSelectedTaskStatus(taskStatus);
    }

    const handleOpenNewTaskMenu = (event) => {
        setAnchorNewTask(event.currentTarget);
    };
    const handleCloseNewTaskMenu = () => {
        setAnchorNewTask(null);
    };



    if (props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Tasks</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <Box sx={{ width:'50%'}} display="flex" justifyContent="flex-start" alignItems="flex-start">
                                <h3>Deserventi Tasks</h3>
                            </Box>
                            <Box sx={{ width:'50%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                {(Security.isSystemUser() || Security.isUserOfClientEmployer()) ?
                                    <React.Fragment></React.Fragment>
                                        :
                                    <Box sx={{ width:'100%', marginTop: 2}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                        <Button onClick={handleOpenNewTaskMenu} variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Task</Button>
                    
                                        <Menu
                                            sx={{ mt: '45px' }}
                                            id="menu-appbar"
                                            anchorEl={anchorNewTask}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchorNewTask)}
                                            onClose={handleCloseNewTaskMenu}
                                        >
                                            <MenuItem key="profile-key" onClick={handleCloseNewTaskMenu}>
                                                <NavLink className="nav-link" to='/rsvti/deserventi/tasks/new-couponstamp'>Reinnoire viza talon</NavLink>
                                            </MenuItem>
                                            <MenuItem key="logout-key" onClick={handleCloseNewTaskMenu}>
                                                <NavLink className="nav-link" to='/rsvti/deserventi/tasks/new-certificate'>Reinnoire adeverinta</NavLink>
                                            </MenuItem>
                                        </Menu>
                                    </Box>
                                }
                            </Box>
                        </Box>                
                    </Box>
                    <hr />

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={4}>
                            {Security.isSystemUser() ?
                                <FormControl fullWidth size="small" margin="dense" variant="standard">
                                    <InputLabel id={'daAngajator-inputLabelId'}>Client</InputLabel>
                                    <Select
                                        labelId={'daClient-selectLabelId'}
                                        id={'daClient'}
                                        value={selectedClientId}
                                        onChange={(event) => handleClientChange(event.target.value) } 
                                        label={'daClient-label'}
                                    >
                                        {
                                            clientSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                                    :
                                <React.Fragment></React.Fragment>
                            }
                        </Grid>
                        <Grid item xs={8}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <CustomSelect 
                                selectId={'taskStatus'} 
                                selectType={SelectTypes.TASK_STATUS} 
                                value={selectedTaskStatus} 
                                callback={handleSelectStatusChange}
                            />
                        </Grid>
                        <Grid item xs={8}>
                        </Grid>
                    </Grid>

                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            rows={taskSelectedData}
                            columns={columns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'taskId', sort: 'desc' }] }
                            }}    
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>

                </Stack>

            </Box>
            </Container>
        );
    }
}

export default TasksDeserventi;